import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import NotFound from "./pages/NotFound.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";
import Contact from "./pages/Contact.tsx";
import TermsConditions from "./pages/TermsConditions.tsx";
import HomeMoves from "./pages/services/HomeMoves.tsx";
import ApartmentMoves from "./pages/services/ApartmentMoves.tsx";
import OfficeRelocations from "./pages/services/OfficeRelocations.tsx";
import SingleItemMoves from "./pages/services/SingleItemMoves.tsx";
import SameDayMoves from "./pages/services/SameDayMoves.tsx";
import Melbourne from "./pages/locations/Melbourne.tsx";
import ComingSoonLocation from "./pages/locations/ComingSoon.tsx";

const comingSoonCities = [
  { city: "Sydney", slug: "sydney" },
  { city: "Brisbane", slug: "brisbane" },
  { city: "Perth", slug: "perth" },
  { city: "Adelaide", slug: "adelaide" },
  { city: "Gold Coast", slug: "gold-coast" },
];

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/home-moves" element={<HomeMoves />} />
          <Route path="/apartment-moves" element={<ApartmentMoves />} />
          <Route path="/office-relocations" element={<OfficeRelocations />} />
          <Route path="/single-item-moves" element={<SingleItemMoves />} />
          <Route path="/same-day-moves" element={<SameDayMoves />} />
          <Route path="/melbourne" element={<Melbourne />} />
          {comingSoonCities.map((c) => (
            <Route
              key={c.slug}
              path={`/${c.slug}`}
              element={<ComingSoonLocation city={c.city} slug={c.slug} />}
            />
          ))}
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
